
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingTemplateAgendaItemDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.min(0)]),
})
;
}
      